import React, {FC} from 'react';
import Lottie from 'react-lottie';
import loaderAnimation from './loader-animation.json';

export const LoaderAnimation: FC = () => {
    return (
        <Lottie
            options={{
                loop: true,
                autoplay: true,
                animationData: loaderAnimation
            }}
        />
    );
};
